import { Box, FormControl, Stack, TextField } from "@mui/material";
import React, { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ParentScreenCtx } from "../../../pages/workbench_build/WorkbenchBuild";
import { useDispatch, useSelector } from "react-redux";
import { cloneDeep, debounce } from "lodash";
import { eachDeep } from "deepdash-es/standalone";
import { treeActions } from "../../../redux/slices/treeSlice";

const ConditionalElse = () => {
	const { t } = useTranslation();
	const [conditionElse, setConditionElse] = useState("");
	const parentScreen = useContext(ParentScreenCtx);
	const { rightTree, leftTree } = useSelector(
		(state) => state.treeData[parentScreen]
	);
	const rightTreeSelectedNode =
		rightTree.tree[rightTree.currentTab].selectedNode;
	const dispatch = useDispatch();

	const submitHandler = (key, value, valuesObj) => {
		const treeData = cloneDeep(
			rightTree?.tree?.[rightTree?.currentTab].translatedData
		);
		let found = false;
		eachDeep(treeData, (obj) => {
			if (found) return;
			if (obj?.key && obj?.key === rightTreeSelectedNode?.key) {
				found = true;
				if (!key) {
					Object.keys(valuesObj).forEach((e) => {
						obj[e] = valuesObj[e];
					});
				} else obj[key] = value;
				if (key === "NAME") obj.title = value;
				dispatch(
					treeActions.setRightTreeSelectedNode({
						screen: parentScreen,
						type: rightTree.currentTab,
						data: obj,
					})
				);
			}
		});
		dispatch(
			treeActions.setRightTreeTransData({
				screen: parentScreen,
				type: rightTree.currentTab,
				data: treeData,
			})
		);
	};

	const debounceChangeHandler = useCallback(debounce(submitHandler, 300), [
		rightTree.currentTab,
		rightTree.tree,
		rightTree.tree[rightTree.currentTab].translatedData,
	]);

	useEffect(() => {
		setConditionElse(rightTreeSelectedNode?.NAME || "");
	}, [rightTreeSelectedNode?.key]);

	return (
		<Box sx={{ padding: "15px 15px" }}>
			<Stack spacing={"15px"}>
				<FormControl className='width-100' size='small'>
					<TextField
						variant='outlined'
						size='small'
						label={t("LBL_COND_FLD_LIST_NAME_ELSE")}
						className={"width-100"}
						value={conditionElse}
						onBlur={(e) => {
              const value = e?.target?.value;
							if (!value){
                const newValue = `${t("UNNAMED")} ${t("CONDITIONAL_FIELDS_ELSE_NAME")}`
                setConditionElse(newValue);
              }
            }}
						onChange={(e) => {
							const value = e?.target?.value ? e?.target?.value : "";
							setConditionElse(e?.target?.value || "");
							debounceChangeHandler("NAME", value || `${t("UNNAMED")} ${t("CONDITIONAL_FIELDS_ELSE_NAME")}`);
						}}
					/>
				</FormControl>
			</Stack>
		</Box>
	);
};

export default ConditionalElse;
